namespace Control.CallbackContainer {
    export class CallbackSource {
        static APP = 'app';
        static MARKER = 'marker';
        static NODE = 'node';
        static LINK = 'link';
        static POLYGON = 'polygon';
        static RANGE_POLYGON = 'range_polygon';
    }
}